import { actionTextColor } from "../../utils/themeContrast";
import React, { useRef, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Modal from '../optioncomponents/Modal';
import promo from '../customerComponents/Promotion';
const MultiItemModal = ({
    show,
    flow,
    index,
    cart,
    handleCallBack
}) => {
    //State
    const [displayShow, setDisplay] = useState(show ? "grid" : "none");
    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { theme, lanIndex, pm, isLanReverse, pax } = React.useContext(UserContext);
    const { height, width } = useWindowDimensions();
    const { addInitCart, updateTitle } = React.useContext(ActionContext);
    const [sh, setSh] = useState(false);
    const [error, setError] = useState([]);
    const [it, setItem] = useState(null);
    const [its, setList] = useState([]);
    const itemRef = useRef(null);

    const handleSubmit = () => {
        if (flow.qtyAccordingToPax) {
            itemRef.current.qty = pax;
        } else {
            itemRef.current.qty = 1;
        }
     
        let item = JSON.parse(JSON.stringify(itemRef.current));

        if (!checkIfSelected()) return;
        if (flow.menuAccordingToSelection) {
            let menu = flow.menuConnection.find(menu => menu.codeId === item.codeId);
            if (menu) {
                updateTitle(menu.menuTitle);
            }
        }
        let newCart = JSON.parse(JSON.stringify(cart));
        newCart.push(item);

        if (pm && pm.length > 0) {
            newCart = promo.clearPromotion(newCart);
            newCart = promo.applyPromotion(pm, newCart);
        }
        newCart = JSON.parse(JSON.stringify(newCart));

        localStorage.setItem("initOrder", JSON.stringify(newCart));

        addInitCart(newCart);
        itemRef.current = null;

        handleCallBack(index);
    }

    useEffect(() => {
        setDisplay(show ? "grid" : "none");
        setList(flow.stockItem);
    }, [show]);

    const checkIfSelected = () => {
        const skipOption = ["No Dressing Please!", "No Crunches"];
        let errorMessages = [];
        let optionArray = itemRef.current.optionArray;

        let alertSubject = `${languageContext[lanIndex].setMeal}: `;
        let quantityCheck = itemRef.current.qty;

        if (itemRef.current.isSetMeal === true) {
            optionArray.forEach((element) => {
                if (element.optionActive === true && element.optionRequired && element.options.length > 0) {
                    let selected = 0;
                    let hasNoOption = false;
                    element.options.forEach((option) => {
                        if (option.active) {
                            selected += (option.qty ? option.qty : 1);
                            if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
                        }
                    });

                    let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);

                    if (!foundActiveOptionArraySelection || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
                        errorMessages.push({
                            errorElement: element.optionTitle,
                            errorMessage: (
                                <>
                                    <b style={{ color: "#CF000D" }}>
                                        {alertSubject + (lanIndex == 0 ? element.optionTitle : element.optionTitle2)}
                                    </b>&nbsp;
                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                </>
                            ),
                        });
                    } else {
               
                        //nested Option
                        foundActiveOptionArraySelection.optionArray &&
                            foundActiveOptionArraySelection.optionArray.forEach((element2) => {
                                if (element2.optionActive === true && element2.optionRequired) {
                                    let selected2 = 0;
                                    element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                                    let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                                    if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                                        errorMessages.push({
                                            errorElement: element2.optionTitle,
                                            errorMessage: (
                                                <>
                                                    <b style={{ color: "#CF000D" }}>
                                                        {(lanIndex === 0 ? element2.optionTitle : element2.optionTitle2)}
                                                    </b>
                                                    {" of "}
                                                    <b style={{ color: "#CF000D" }}>
                                                        {alertSubject + (lanIndex === 0 ? element.optionTitle : element.optionTitle2)}
                                                    </b>&nbsp;
                                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                                </>
                                            ),
                                        });
                                    }
                                }
                            });
                    }
                } else if (element.optionActive === true && element.options.length > 0) {
                    //even option is not compulsory, but nested may be compulsory
                    let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);
                    foundActiveOptionArraySelection && foundActiveOptionArraySelection.optionArray &&
                        foundActiveOptionArraySelection.optionArray.forEach((element2) => {
                            if (element2.optionActive === true && element2.optionRequired) {
                                let selected2 = 0;
                                element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                                let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                                if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                                    errorMessages.push({
                                        errorElement: element2.optionTitle,
                                        errorMessage: (
                                            <>
                                                <b style={{ color: "#CF000D" }}>
                                                    {((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element2.optionTitle : element2.optionTitle2)}
                                                </b>
                                                {" of "}
                                                <b style={{ color: "#CF000D" }}>
                                                    {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                                                </b>&nbsp;
                                                <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                            </>
                                        ),
                                    });
                                }
                            }
                        });
                }
            });
        } else {
            optionArray.forEach((element) => {
                if (element.optionActive === true && element.optionRequired) {
                    let checkActive = false;
                    let selected = 0;
                    let hasNoOption = false;
                    element.options.forEach((option) => {
                        if (option.active === true) {
                            checkActive = true;
                            if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
                            selected += (option.qty ? option.qty : 1);
                        }
                    });

                    if ((checkActive === false && !element.isMultiple) || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
                        errorMessages.push({
                            errorElement: element.optionTitle,
                            errorMessage: (
                                <>
                                    <b style={{ color: "#CF000D" }}>{lanIndex === 0 ? element.optionTitle : element.optionTitle2}</b>
                                    &nbsp;
                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                </>
                            ),
                        });
                    }
                }
            });
        }

        if (quantityCheck < 1) {
            errorMessages.push({
                errorElement: "Quantity",
                errorMessage: (
                    <>
                        <b style={{ color: "#CF000D" }}>Quantity</b> cannot be less than{" "}
                        <b>1</b> please re-adjust.
                    </>
                ),
            });
        }

        if (errorMessages.length > 0) {
          
            setError(errorMessages);
            setSh(true);
            return false;
        }
        return true;
    };

    let menuWidth = (Math.min(width, 550));
    return (
        <React.Fragment>
            <ModalContainer display={displayShow}>
                <ModalMain id="menu_scroll" themeContext={themeContext}>
                    <MenuWrapper
                        className="no-scrollbars"
                    >
                        <CategoryTitle>
                            {flow.title}
                        </CategoryTitle>
                        <MenuItemWrapper>
                            {flow.stockItem.map((it, k) =>
                                <ItemContainer
                                    height={menuWidth / 2 + 36}
                                    width={menuWidth / 2}
                                    active={itemRef.current != null && itemRef.current.codeId == it.codeId}
                                    themeContext={themeContext}
                                    theme={theme}
                                    key={k}
                                    style={{ width: menuWidth / 2 }}
                                    onClick={(e) => {
                                        itemRef.current = JSON.parse(JSON.stringify(it));
                                        setItem(it);
                                    }}
                                >
                                    <ItemDisplay
                                        key={it.codeId}
                                        className="item-img"
                                        data-bg={it.image}

                                    >
                                        {it.isSoldOut &&
                                            <SoldOut src="/soldout.png" />
                                        }
                                        <IconHolder icons={it.icons} enlarge={true} />

                                    </ItemDisplay>
                                    <ItemTitleWrapper themeContext={themeContext} size={0} enlarge={true}>
                                        <ItemTitle themeContext={themeContext} title={it.title} theme={theme} enlarge={true}>
                                            {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
                                                it.title : it.title2
                                            }
                                        </ItemTitle>
                                    </ItemTitleWrapper>
                                </ItemContainer>

                            )}
                        </MenuItemWrapper>
                    </MenuWrapper>
                    <AddCartButtonContainer>
                        <AddCartButton
                            width={width}
                            themeContext={themeContext}
                            onClick={() => {
                                handleSubmit();
                            }}
                        >
                            {languageContext[lanIndex].submit}
                        </AddCartButton>
                    </AddCartButtonContainer>
                </ModalMain>
            </ModalContainer>
            <Modal show={sh} setShow={setSh} error={error} />
        </React.Fragment>
    );
};

export default MultiItemModal;

const IconHolder = ({ icons, enlarge }) => {
    const userContext = React.useContext(UserContext);
    return (

        <IconsContainer enlarge={true}>
            {Array.isArray(icons) && icons.map((iconsLink, index) => (
                <Icons
                    enlarge={true}
                    key={index + iconsLink + "Icons"}
                    iconsLink={iconsLink}
                    iconsImg={userContext.icons}
                />
            ))}
        </IconsContainer>
    );
};
const Icons = styled.div`
  height: ${props => props.enlarge ? 36 : 30}px;
  width: 56px;
  background-image: url(${(props) => props.iconsImg[props.iconsLink]});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
`;
const IconsContainer = styled.div`
  position: relative;
  display: block;
  font-size: ${props => props.enlarge ? 28 : 25}px;
  min-width: ${props => props.enlarge ? 36 : 30}px;
  height: ${props => props.enlarge ? 36 : 30}px;
`;
const SoldOut = styled.img`
  width: 100%;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
`;

const MenuWrapper = styled.div`
 
`;
const CategoryTitle = styled.div`
  display: flex;
  margin-left: 16px;
  align-items: center;
  padding-top: 36px;
  font-size: 18px;
  font-weight: 700;
`;

const MenuItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  justify-content: center;
  box-shadow: 0px 0px 4px 0px darkgray; 
  border-radius: 8px;
  margin: ${(props) => "8px"};
  margin-top:${(props) => "8px"};
  height: ${(props) => (props.height ? props.height + "px" : props.size != 2 ? "90%" : "80%")};
  width: ${(props) => (props.width ? props.width + "px" : "90%")};
  border: ${(props) => props.active ? `3px solid ${props.themeContext.primaryColor}` : ""};
  opacity: ${(props) => props.active ? 1 : 0.8};
  z-index: 1;
`;


const ItemDisplay = styled.div`
  display: grid;
  position: relative;
  flex: 1;
  justify-content: flex-end;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  height: 72%;
  min-width: 100%;
  //Image based on image url in item given
  background-image: url(${(props) => props["data-bg"]});
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
`;

const ItemTitleWrapper = styled.div`
  display: grid;
  flex: ${(props) => '0.3'};
  justify-content: ${(props) => props.enlarge ? "flex-start" : "center"};;
  padding: 8px 0px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-top: 1px solid ${(props) => props.themeContext.borderColor};
  background-color:${(props) => props.themeContext.optionHeaderBackgroundColor};
`;

const ItemTitle = styled.div`
  display: -webkit-box;
  flex: 0.3;
  place-content: center;
  text-align: ${(props) => props.enlarge ? "left" : "center"};
  font-weight: ${(props) => props.enlarge ? 600 : 400};
  padding: 0 ${(props) => props.enlarge ? 12 : 8}px;
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: ${(props) => 14}px;
  color: ${(props) => props.themeContext.fontSecondary};
  -webkit-line-clamp: 3;
  word-wrap:break-word;
  -webkit-box-orient: vertical;
  overflow:hidden;
`;


const AddCartButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 10px;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 25;
  width: 100%;
  max-width: 500px;
`;
const ModalContainer = styled.div`
    display: ${(props) => props.display};
    position: fixed;
    background: #fff;
    top: 0;

    width: 100vw;
    max-width:550px;
    height: 100vh;
    z-index: 10;
    max-width: 550px;
  `;

const ModalMain = styled.div`
    position: relative;
    font-family: ${(props) => props.themeContext.fontFamily};
    background: #fff;
    z-index: 10;
    width: 100vw;
    max-width: 550px;
    height: calc(100vh);
    overflow: auto;
  `;
const AddCartButton = styled.div`
  display: flex;
 
  text-align: center;
  color: ${props => actionTextColor(props.themeContext, props.themeContext.cartColor2)};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 16px;
  background-color: ${(props) => props.themeContext.cartColor2};
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  height: 40px;
  right: 20px;
  left: 20px;
  /*width: 50%; */
  bottom: 10px;
  box-shadow: 0px 0px 13px rgb(0 0 0 / 90%);
  z-index: 99;
  border-radius: 6px;
  width: 85%;
  max-width: 400px;
`;